/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient, useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { WorkItem } from "./@types";
import { PaginatedParams, PaginatedResultV2 } from "services/@types";

const fetchWorkItems = async (
  params: PaginatedParams
): Promise<PaginatedResultV2<WorkItem>> => {
  const { data } = await apiInputService.get(`/workItem/paginated?`, {
    params: { ...params },
  });

  return data?._metadata as PaginatedResultV2<WorkItem>;
};

export const useWorkItems = (
  params?: PaginatedParams,
  options?: {
    staleTime: number;
    onSuccess: (data: PaginatedResultV2<WorkItem>) => void;
  }
) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["work-items", subscription?.subscriptionId, params],
    () => fetchWorkItems(params),
    {
      ...options,
      enabled: !!subscription?.subscriptionId,
      keepPreviousData: true,
    }
  );
};

export const prefetchData = (
  queryClient: QueryClient,
  params: any,
  subscription: string
) => {
  queryClient.prefetchQuery(
    ["dashboard", "atvs", "department", subscription, params],
    () => fetch(params),
    {
      staleTime: 1000 * 60 * 5,
    }
  );
};
